export const FEEDBACK_TYPE_NONE = 'none';
export const FEEDBACK_TYPE_FULL = 'full';

export const FeedbackType = {
  None: FEEDBACK_TYPE_NONE,
  Full: FEEDBACK_TYPE_FULL,
};
